export default "__VITE_ASSET__Bx_KWCL3__"